module.exports = __webpack_public_path__ + "img/rebuild_yeh_pc2.2c134ac0.jpg";